import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { StorageImage } from '@aws-amplify/ui-react-storage';
import { Storage } from '@aws-amplify/storage'

const PlantPreviewCard = ({
                              plant,
                              unitmeasurement = "imperial",
                              mode = "select" // "select" | "rotation"
                          }) => {
    if (!plant) return null;

    const imageKey =
        "card_icons/" +
        plant.species
            .toLowerCase()
            .replace(/['’‘‛`´]/g, "")
            .replace(/[^a-z0-9]+/g, "_")
            .replace(/^_+|_+$/g, "") +
        ".png";

    const showDates = mode === "rotation";

    function getWeatherType(plant) {
        if (!plant?.minimumTemp || !plant?.maximumTemp) return null;
        const min = parseFloat(plant.minimumTemp);
        const max = parseFloat(plant.maximumTemp);
        return (min + max) / 2 >= 70 ? "warm" : "cool";
    }

    return (
        <Card
            outline
            color="secondary"
            className="border mb-3 h-100"
            style={{ border: "2px solid #dee2e6" }}
        >
            <CardBody style={{ padding: "6px" }}>
                {/* Image */}
                <Row className="mb-2">
                    <Col md={12} className="text-center">
                        <StorageImage
                            alt={plant.species}
                            imgKey={imageKey}
                            accessLevel="guest"
                            style={{
                                width: "100%",
                                maxWidth: "280px",
                                margin: "auto"
                            }}
                        />
                    </Col>
                </Row>

                {/* Title */}
                <Row className="mb-1">
                    <Col md={12}>
                        <strong style={{ fontSize: "1.1em" }}>
                            {plant.species}
                        </strong>
                    </Col>
                </Row>

                {/* Core info */}
                <Row>
                    <Col xs={6}>Season</Col>
                    <Col xs={6}>{plant.season}</Col>
                </Row>

                <Row>
                    <Col xs={6}>Family</Col>
                    <Col xs={6}>{plant.plant_family || "—"}</Col>
                </Row>
                {showDates &&
                <Row>
                    <Col xs={6}>Days to Harvest</Col>
                    <Col xs={6}>{plant.daysToHarvest}</Col>
                </Row>
                }
                <Row>
                    <Col xs={6}>Nutrient Role</Col>
                    <Col xs={6}>
                        {plant.nutrient_role
                            ?.replace("_", " ")
                            .replace(/\b\w/g, c => c.toUpperCase())}
                    </Col>
                </Row>

                {/* Yield */}
                <Row className="mt-1">
                    <Col xs={6}>
                        Yield / Plant ({unitmeasurement === "imperial" ? "oz" : "g"})
                    </Col>
                    <Col xs={6}>
                        {plant.yield_per_plant_ounces ?? "—"}
                    </Col>
                </Row>

                {/* Rotation-only dates */}
                {showDates && plant.seedStartDate && (
                    <>
                        <hr className="my-2" />

                        <Row>
                            <Col xs={6}>Seed</Col>
                            <Col xs={6}>
                                {new Date(plant.seedStartDate).toLocaleDateString()}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={6}>Transplant</Col>
                            <Col xs={6}>
                                {new Date(plant.transplantDate).toLocaleDateString()}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={6}>Harvest</Col>
                            <Col xs={6}>
                                {new Date(plant.harvestDate).toLocaleDateString()}
                            </Col>
                        </Row>
                    </>
                )}
            </CardBody>
        </Card>
    );
};

export default PlantPreviewCard;
